import type { ReactNode } from 'react';

import { CustomBlockquoteIcon } from '@nesso/ui/icons/custom-blockquote-icon';
import { cn } from '@nesso/ui/lib/utils';
import { DialogCloseButton } from '@nesso/ui/primitives/dialog';
import { PopoverClose, PopoverContent } from '@nesso/ui/primitives/popover';

import { PopoverTooltipButton } from '@/shared/ui/common/popover-tooltip-button';

type Props = {
    open: boolean;
    onOpen: (open: boolean) => void;
    children: ReactNode;
};

export function TranscriptDetailsPopover({ open, onOpen, children }: Props) {
    const onClose = () => onOpen(false);
    return (
        <PopoverTooltipButton
            open={open}
            onOpenChange={onOpen}
            popoverProps={{ modal: true }}
            tooltipContent={<p>Show transcript</p>}
            tooltipContentProps={{ showArrow: false }}
            popoverContent={
                <PopoverContent
                    className="relative flex flex-col w-154.75 max-w-[calc(100vw-2rem)] h-145.5 p-0 pt-6 gap-4 overflow-hidden"
                    side="bottom"
                    align="start"
                    sideOffset={8}
                >
                    <PopoverClose asChild>
                        <DialogCloseButton
                            className="absolute top-4 right-4 hover:bg-accent hover:text-muted-foreground"
                            onClick={onClose}
                        />
                    </PopoverClose>
                    <h3 className="shrink-0 px-6">Session transcript</h3>
                    {children}
                </PopoverContent>
            }
            wrapPopoverContent={false}
            buttonProps={{
                variant: 'outline',
                size: 'icon',
                className: cn(
                    'shadow-[0_1px_2px_0_rgba(0,0,0,0.15)]',
                    open && 'bg-accent/50 text-accent-foreground',
                ),
                'aria-label': 'Show transcript',
            }}
        >
            <CustomBlockquoteIcon />
        </PopoverTooltipButton>
    );
}
